<template>
  <div class="login-header">
    <div class="login-header--left">
      <div class="header-item title">{{ systemName }}</div>
    </div>
    <div class="login-header--right">
      <!-- 切换语言 -->
      <a-dropdown overlayClassName="23">
        <div class="header-item">Language</div>
        <a-menu
          slot="overlay"
          class="dropdown-wrap dropdown-language"
          @click="changeLanguage"
        >
          <a-menu-item key="zh_CN" :disabled="$i18n.locale === 'zh_CN'">
            中文
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item key="en" :disabled="$i18n.locale === 'en'">
            English
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['systemName'])
  },

  methods: {
    // 切换语言
    changeLanguage(v) {
      if (v.key !== this.$i18n.locale) {
        this.$confirm({
          title: this.$t('public.switchLanguage'),
          content: '',
          onOk: () => {
            this.$store.commit('SET_LOCALELANGUAGE', v.key)
          },
          onCancel() {}
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.login-header {
  height: 100%;
  background-color: @headerBackColor;
  display: flex;
  justify-content: space-between;
  .login-header--left,
  .login-header--right {
    flex-grow: 1;
    display: flex;
  }
  .login-header--right {
    justify-content: flex-end;
  }
  .header-item {
    padding: 0 30px;
    display: flex;
    align-items: center;
    color: @headerFontColor;
    cursor: pointer;
  }
  .title {
    font-size: 16px;
    cursor: default;
  }
}
</style>
